const BanksConciliacion = [
  {label: "BCP", value: "BCP"},
  {label: "Interbank", value: "Interbank"}
]

export default BanksConciliacion;